/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/


import { Component, ViewEncapsulation, AfterViewInit, OnDestroy, OnInit, AfterViewChecked, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { CheckedUncheckedPipe } from '../../shared/pipes/checkedUnchecked.pipe';
import { NavigationExtras, Router, ActivatedRoute } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { KnowledgeBaseFilterInfo } from '../model/knowledgebasefilterinfo';
import { ItemCategoriesResultEntity } from '../../shared/model/itemcategoriesresponse';
import { ItemTypesResultEntity } from '../../shared/model/itemtypesresponse';
import { KbaService } from '../services/kba.service';
declare var $: any;

@Component({
  selector: 'zsd-knowledgebasefilter',
  templateUrl: '../view/knowledgebasefilter.component.html',
  providers: [
    CheckedUncheckedPipe
  ],
  encapsulation: ViewEncapsulation.None
})
export class KnowledgeBaseFilterComponent implements AfterViewInit, OnDestroy, OnInit, AfterViewChecked {
  static searchString = null;
  static selectedCategories = null;
  static selectedItemTypes = null;
  static categoryIds = null;
  static kbaType = null;
  categoryResults = new Array<ItemCategoriesResultEntity>();
  itemTypesResults = new Array<ItemTypesResultEntity>();
  searchCategory:  string;
  searchItemType: string;
  knowledgeBaseFilterInfo: KnowledgeBaseFilterInfo = new KnowledgeBaseFilterInfo();
  searchSubscription: Subscription;
  windowSize;
  isFilterOpen: boolean;

  categoryChecked = false;
  itemTypeChecked = false;

  readonly KBA_TYPE_ARTICLE = 1000;
  readonly KBA_TYPE_FAQ = 2000;
  readonly KBA_TYPE_SOLUTION = 4000;
  allKba = 'all';
  article = 'article';
  faqs = 'faqs';
  solution = 'solution';

  constructor(private knowledgebaseservice: KbaService, private checkedUncheckedPipe: CheckedUncheckedPipe,
     private router: Router, private route: ActivatedRoute, private location: PlatformLocation) {
    this.windowSize = window.innerWidth;
    this.initializeParameters();
    // AOT Changes - Vaibhav
    this.location.onPopState(() => {
      this.ngOnInit();
    });
    this.location.onHashChange(() => {
      this.ngOnInit();
    });
  }

  ngOnInit() {
    this.initFilter();
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    // a hack to fix filter display issue when protrait and landscape mode has mobile and desktop layout respectively.
  }
  initFilter() {
    let categoryIds = new Array<number>();
    let itemTypeIds = new Array<number>();
    this.route.queryParams.subscribe(params => {
      if (params['searchTerm']) {
        this.knowledgeBaseFilterInfo.searchTerm = JSON.parse(params['searchTerm']);
      }
      if (params['categoryIds']) {
        categoryIds = JSON.parse(params['categoryIds']);
        if (categoryIds.length > 0) {
          this.categoryChecked = true;
        }
      }
      if (params['itemTypeIds']) {
        itemTypeIds = JSON.parse(params['itemTypeIds']);
        if (itemTypeIds.length > 0) {
          this.itemTypeChecked = true;
        }
      }
      if (params['kbaType']) {
        this.knowledgeBaseFilterInfo.kbaTabType = JSON.parse(params['kbaType']);
        if (this.knowledgeBaseFilterInfo.kbaTabType === this.allKba) {
             this.knowledgeBaseFilterInfo.kbaType = null;
        } else if (this.knowledgeBaseFilterInfo.kbaTabType === this.article) {
        this.knowledgeBaseFilterInfo.kbaType = this.KBA_TYPE_ARTICLE;
        } else if (this.knowledgeBaseFilterInfo.kbaTabType === this.faqs) {
        this.knowledgeBaseFilterInfo.kbaType = this.KBA_TYPE_FAQ;
        } else if (this.knowledgeBaseFilterInfo.kbaTabType === this.solution) {
        this.knowledgeBaseFilterInfo.kbaType = this.KBA_TYPE_SOLUTION;
        }
      } else {
        this.knowledgeBaseFilterInfo.kbaType = null;
      }
    });

    if (this.knowledgeBaseFilterInfo.searchTerm !== null) {
      KnowledgeBaseFilterComponent.searchString = this.knowledgeBaseFilterInfo.searchTerm.toString();
    }
    this.getCategories(categoryIds);
    this.getItemtypes(itemTypeIds);
  }

  initializeParameters() {
      KnowledgeBaseFilterComponent.selectedCategories = null;
      KnowledgeBaseFilterComponent.selectedItemTypes = null;
      KnowledgeBaseFilterComponent.searchString = null;
      this.knowledgeBaseFilterInfo.searchTerm = null;
      this.knowledgeBaseFilterInfo.kbaTabType = null;
  }


  ngAfterViewChecked() {
    this.windowSize = window.innerWidth;
  }

  closeFilter() {
    this.isFilterOpen = false;
    $('#knowledgebase_filterpanel_control').width('0');
    $('body').css('overflow-y', 'auto');
  }

  getCategories(categoryIds: Array<number>) {
    this.knowledgebaseservice.getItemCategories().subscribe(
      (categoryResponse: ItemCategoriesResultEntity[]) => {
            this.categoryResults = categoryResponse;
            for (let categoryId of categoryIds) {
              for (let j = 0; j < this.categoryResults.length; j++) {
                if (this.categoryResults[j].categoryId === categoryId) {
                  this.categoryResults[j].checked = true;
                }
              }
            }
            this.categoryResults = this.checkedUncheckedPipe.transform(this.categoryResults, 'categoryName');
      }
    );
  }

  getItemtypes(itemTypeIds: Array<number>) {
    this.knowledgebaseservice.getItemTypes().subscribe(
      (itemTypesResponses: ItemTypesResultEntity[]) => {
        this.itemTypesResults = itemTypesResponses;

        for (let itemTypeId of itemTypeIds) {
          for (let j = 0; j < this.itemTypesResults.length; j++) {
            if (this.itemTypesResults[j].itemTypeId === itemTypeId) {
              this.itemTypesResults[j].checked = true;
            }
          }
        }
        this.itemTypesResults = this.checkedUncheckedPipe.transform(this.itemTypesResults, 'itemTypeName');
      });
  }

  applyFilter() {
    this.categoryResults = this.categoryResults.filter(category => category.checked === true);
    this.itemTypesResults = this.itemTypesResults.filter(itemType => itemType.checked === true);

    let categoryIds = new Array<number>();
    for (let itemCategory of this.categoryResults) {
      categoryIds.push(itemCategory.categoryId);
    }

    let itemTypeIds = new Array<number>();
    for (let itemType of this.itemTypesResults) {
      itemTypeIds.push(itemType.itemTypeId);
    }

    if (KnowledgeBaseFilterComponent.searchString !== null) {
      KnowledgeBaseFilterComponent.searchString = JSON.stringify(KnowledgeBaseFilterComponent.searchString);
    }

      if (this.knowledgeBaseFilterInfo.kbaType === null) {
            this.knowledgeBaseFilterInfo.kbaTabType = this.allKba;
      } else if ( this.knowledgeBaseFilterInfo.kbaType === this.KBA_TYPE_ARTICLE) {
        this.knowledgeBaseFilterInfo.kbaTabType = this.article;
      } else if ( this.knowledgeBaseFilterInfo.kbaType === this.KBA_TYPE_FAQ) {
        this.knowledgeBaseFilterInfo.kbaTabType = this.faqs;
      } else if ( this.knowledgeBaseFilterInfo.kbaType === this.KBA_TYPE_SOLUTION) {
        this.knowledgeBaseFilterInfo.kbaTabType = this.solution;
      }
      this.knowledgeBaseFilterInfo.kbaTabType = JSON.stringify(this.knowledgeBaseFilterInfo.kbaTabType);

    if (categoryIds.length > 0) {
      KnowledgeBaseFilterComponent.selectedCategories = JSON.stringify(categoryIds);
      this.knowledgeBaseFilterInfo.categoryIds = categoryIds;
    }
    if (itemTypeIds.length > 0) {
      KnowledgeBaseFilterComponent.selectedItemTypes = JSON.stringify(itemTypeIds);
      this.knowledgeBaseFilterInfo.itemTypeIds = itemTypeIds;
    }

    let navigationExtras: NavigationExtras = {
      queryParams: {
        'searchTerm': KnowledgeBaseFilterComponent.searchString,
        'categoryIds': KnowledgeBaseFilterComponent.selectedCategories,
        'itemTypeIds': KnowledgeBaseFilterComponent.selectedItemTypes,
        'kbaType': this.knowledgeBaseFilterInfo.kbaTabType
      },
      queryParamsHandling: 'merge'
    };

    this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
      this.router.navigate([CommonConstants.SELFHELP_COMPONENT], navigationExtras ));

    this.closeFilter();
  }

  // will be called on click of clear button
  clearFilter() {
    this.resetFilter();
    if (KnowledgeBaseFilterComponent.searchString !== null) {
      KnowledgeBaseFilterComponent.searchString = JSON.stringify(KnowledgeBaseFilterComponent.searchString);
    }
    if (this.knowledgeBaseFilterInfo.kbaTabType !== null) {
      KnowledgeBaseFilterComponent.kbaType = JSON.stringify(this.knowledgeBaseFilterInfo.kbaTabType);
    }

    let navigationExtras: NavigationExtras = {
      queryParams: {
        'searchTerm': KnowledgeBaseFilterComponent.searchString,
        'kbaType': KnowledgeBaseFilterComponent.kbaType
      },
      queryParamsHandling: 'merge'
    };
    this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
      this.router.navigate([CommonConstants.SELFHELP_COMPONENT], navigationExtras ));

    this.closeFilter();
  }

  // will reset the selected filter values
  resetFilter() {
    KnowledgeBaseFilterComponent.selectedCategories = null;
    KnowledgeBaseFilterComponent.selectedItemTypes = null;
    this.searchCategory = '';
    this.searchItemType = '';
    this.categoryResults.forEach(category => category.checked = false);
    this.itemTypesResults.forEach(itemType => itemType.checked = false);
  }

  ngAfterViewInit() {
    $(document).ready(function () {
      $('[data-toggle=popover]').popover();
    });
  }


  ngOnDestroy() {
  }
}
